import { type ReactNode } from 'react';
import { Button, Header as RamenHeader } from '@hungryroot/ramen';

interface Props {
  className?: string;
  onSaveAndExitClick?(): void;
  saveAndExitButtonText?: string;
  children?: ReactNode;
  transparent?: boolean;
  centerElement?: ReactNode[];
}

const SaveAndExitButton = ({
  saveAndExitButtonText,
  onSaveAndExitClick,
}: Pick<Props, 'onSaveAndExitClick' | 'saveAndExitButtonText'>) => {
  if (!onSaveAndExitClick) return null;
  return (
    <Button
      style="muted"
      prominence="tertiary"
      size="medium"
      textPrimary={saveAndExitButtonText}
      onClick={(e) => {
        e.preventDefault();
        onSaveAndExitClick();
      }}
      buttonType="button"
    />
  );
};

export function Header({
  children,
  saveAndExitButtonText = 'Save and exit',
  className,
  onSaveAndExitClick,
  transparent = false,
  centerElement,
}: Props) {
  const rightAlignedActions = onSaveAndExitClick
    ? [
        <SaveAndExitButton
          saveAndExitButtonText={saveAndExitButtonText}
          onSaveAndExitClick={onSaveAndExitClick}
        />,
      ]
    : [];

  return (
    <RamenHeader
      className={className}
      rightAlignedActions={rightAlignedActions}
      transparent={transparent}
      centerElement={centerElement}
    >
      {children}
    </RamenHeader>
  );
}
